import { render, staticRenderFns } from "./ShippingLabel.vue?vue&type=template&id=de5947dc"
import script from "./ShippingLabel.vue?vue&type=script&lang=js"
export * from "./ShippingLabel.vue?vue&type=script&lang=js"
import style0 from "./ShippingLabel.vue?vue&type=style&index=0&id=de5947dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports